import Icon from "~/components/shared/Icon";
import {
  HoverCard,
  HoverCardTrigger,
  HoverCardContent,
  HoverCardPortal,
} from "~/components/shared/HoverCard";

export default function Signature({
  algorithm,
  onNestedLinkTrigger,
}: {
  algorithm: string;
  onNestedLinkTrigger: (e: React.MouseEvent | React.KeyboardEvent) => void;
}) {
  const description = (
    <>
      This step was signed using the <span className="font-bold">{algorithm}</span> algorithm.
    </>
  );

  return (
    <HoverCard>
      <HoverCardTrigger className="job-stats flex flex-none cursor-help items-center">
        <Icon icon="custom/outline/14x/signature" className="h-3.5 w-3.5 flex-shrink-0" />
        {/* Description for screenreader */}
        <span className="sr-only">{description}</span>
      </HoverCardTrigger>

      <HoverCardPortal>
        <HoverCardContent
          size="md"
          className="text-center"
          onClick={onNestedLinkTrigger}
          onKeyDown={onNestedLinkTrigger}
        >
          {description}
        </HoverCardContent>
      </HoverCardPortal>
    </HoverCard>
  );
}
